module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/big/6-77a47ad02282d4ebe3d68828a4d967b1.webp";